import Vue from 'vue'

async function requestWithRetry(requestFunction, maxRetries = 3) {
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      return await requestFunction()
    } catch (error) {
      console.log(`Attempt ${attempt} failed:`, error)
      if (attempt === maxRetries) {
        console.log(`Maximum retries reached: ${attempt}`, error)
      }
    }
  }
}

export default {
  fetchClassifications(payload) {
    return Vue.http.post('app-services/v2/insight-classification/search', payload)
  },
  fetchCategories() {
    return Vue.http.get('app-services/v2/insight-category/list')
  },
  fetchFeedbackCount({ filters }) {
    return Vue.http.post('app-services/v2/insight-classification/feedback/count', { filters })
  },
  fetchPopulatedClassifications({ filters, search, limit, skip }) {
    return Vue.http.post('app-services/v2/insight-classification/search-detailed', {
      filters,
      search,
      limit,
      skip
    })
  },
  fetchFeedbackCountBreakdown({ filters }) {
    return Vue.http.post('app-services/v2/insight-classification/feedback/count-breakdown', {
      filters
    })
  },
  fetchSummaries({ filters, search }) {
    const request = () =>
      Vue.http.post('app-services/v2/insight-classification/summary', { filters, search })
    return requestWithRetry(request)
  }
}
